import { OverlayRef } from "@angular/cdk/overlay";
import { InjectionToken } from "@angular/core";

export enum ElementPosition {
    TopLeft,
    TopRight,
    CenterLeft,
    CenterRight,
    BottomLeft,
    BottomRight,
    LeftScreenHeight,
    RightScreenHeight,
    TopScreenWidth,
    BottomScreenWidth,
    FullScreen
  }
  
  export const OVERLAY_DATA = new InjectionToken<any>('OVERLAY_DATA');
  export const OVERLAY_REF = new InjectionToken<OverlayRef>('OVERLAY_REF');